__webpack_require__.p = "https://gcathaystodwl.cathaylife.com.tw/ODBA/static/";